<app-page-title-gold input_title="Order" />

<div class="page">
  <div class="cards-container">
    @for (order of Orders$ | async; track order) {
    <div class="con">
      <div
        class="item_card_container"
        #swipeItem
        (touchstart)="onTouchStart($event, order.itemId)"
        (touchmove)="onTouchMove($event, order.itemId)"
        (touchend)="onTouchEnd(order.itemId)"
      >
        <app-cart-card [ItemId]="order.itemId" [order]="order"></app-cart-card>
      </div>
      <div
        class="delete-btn hidden"
        [id]="'delete-btn-' + order.itemId"
        (click)="deleteItem(order.itemId)"
      >
        <svg class="navigation__icon">
          <use xlink:href="images/sprites2.svg#icon-bin"></use>
        </svg>
      </div>
    </div>
    }
  </div>
</div>

<app-page-title-gold input_title="{{ totalTitle() }}" />
<div class="container">
  <button class="total">{{ sum }} TL</button>
</div>

<app-menu-footer />
